// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__NT81e","contentWrapper":"styles_contentWrapper__mF8_5","content":"styles_content__tF3b8"};